import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Popup } from '@/components/UI/Popup/Popup';

const getGridTemplate = (columns: number) => css`
  grid-template-columns: repeat(${columns}, minmax(0, 1fr));
`;

export const AdImages = styled.div<{ name?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AdImagesGrid = styled.div`
  display: grid;
  ${getGridTemplate(4)}
  gap: 15px;

  @media (min-width: 744px) and (max-width: 949px) {
    ${getGridTemplate(3)}
  }

  @media (min-width: 545px) and (max-width: 743px) {
    ${getGridTemplate(4)}
  }

  @media (max-width: 544px) {
    ${getGridTemplate(3)}
  }
`;

export const AdImagesAddButton = styled.button<{
  $height: string;
  $isFullWidth?: boolean;
}>`
  border-radius: 14px;
  border: ${({ theme, $isFullWidth }) =>
    $isFullWidth
      ? `1px dashed ${theme.palette.system.blue}`
      : `1px solid ${theme.palette.primary.border}`};
  background-color: ${({ theme }) => theme.palette.secondary.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  height: ${({ $height }) => $height};
  color: ${({ theme }) => theme.palette.system.blue};
  font-size: 15px;
  font-weight: 400;
  width: 100%;
  aspect-ratio: 1;
  cursor: pointer;
`;

export const AdImagesCaption = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.secondary.labels};

  &:first-of-type {
    margin-top: 20px;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (max-width: 949px) {
    font-size: 12px;

    &:first-of-type {
      margin-top: 15px;
    }

    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
`;

export const AdImagesUploadErrorPopup = styled(Popup)`
  width: 445px;
  max-width: 95dvw;
  border-radius: 14px;
`;

export const AdImagesUploadErrorPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 50px;

  @media (max-width: 949px) {
    padding: 25px 20px 20px;
  }
`;

export const AdImagesUploadErrorPopupTitle = styled(Typography.Title).attrs({
  $variant: '2',
})`
  font-size: 20px;
  margin-bottom: 20px;

  @media (max-width: 949px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

export const AdImagesUploadErrorPopupDescription = styled(Typography.Body)`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
  margin-bottom: 30px;

  @media (max-width: 949px) {
    font-size: 15px;
    margin-bottom: 20px;
  }
`;

export const AdImagesHelperTextBox = styled.div`
  display: flex;
  align-items: center;
  border-radius: 14px;
  gap: 10px;
  padding: 10px 20px;
  margin-bottom: 15px;
  background: ${({ theme }) => theme.palette.system.redToWhite};
`;

export const AdImagesHelperText = styled(Typography.Text)`
  font-size: 14px;

  @media (max-width: 949px) {
    font-size: 12px;
  }
`;
